import { memo } from 'react';

import type { IconProperties } from './types';

/**
 * Blox-Design data table toolbar hint icon (node 75644:8226).
 */
const InfoIcon = ({ width = 12, height = 12, color = '#8B5CF6' }: IconProperties) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 12 12'
    fill='none'
  >
    <path
      d='M6 12C7.18669 12 8.34673 11.6481 9.33342 10.9888C10.3201 10.3295 11.0892 9.39246 11.5433 8.2961C11.9974 7.19975 12.1162 5.99335 11.8847 4.82946C11.6532 3.66558 11.0818 2.59648 10.2426 1.75736C9.40353 0.918247 8.33443 0.346802 7.17054 0.115291C6.00666 -0.11622 4.80026 0.00259972 3.7039 0.456726C2.60754 0.910851 1.67047 1.67989 1.01118 2.66658C0.351894 3.65328 0 4.81331 0 6C0.00172054 7.59077 0.634414 9.1159 1.75926 10.2407C2.88411 11.3656 4.40923 11.9983 6 12ZM6 2.5C6.14834 2.5 6.29334 2.54399 6.41668 2.6264C6.54002 2.70881 6.63614 2.82595 6.69291 2.96299C6.74968 3.10003 6.76453 3.25083 6.73559 3.39632C6.70665 3.54181 6.63522 3.67544 6.53033 3.78033C6.42544 3.88522 6.2918 3.95665 6.14632 3.98559C6.00083 4.01453 5.85003 3.99968 5.71299 3.94291C5.57594 3.88615 5.45881 3.79002 5.3764 3.66668C5.29399 3.54334 5.25 3.39834 5.25 3.25C5.25 3.05109 5.32902 2.86032 5.46967 2.71967C5.61032 2.57902 5.80109 2.5 6 2.5ZM5.5 5H6C6.26522 5 6.51957 5.10536 6.70711 5.2929C6.89464 5.48043 7 5.73479 7 6V9C7 9.13261 6.94732 9.25979 6.85355 9.35356C6.75979 9.44732 6.63261 9.5 6.5 9.5C6.36739 9.5 6.24022 9.44732 6.14645 9.35356C6.05268 9.25979 6 9.13261 6 9V6H5.5C5.36739 6 5.24022 5.94732 5.14645 5.85356C5.05268 5.75979 5 5.63261 5 5.5C5 5.36739 5.05268 5.24022 5.14645 5.14645C5.24022 5.05268 5.36739 5 5.5 5Z'
      fill={color}
    />
  </svg>
);

export default memo(InfoIcon);
